import { State } from '@hookstate/core';
import React from 'react';
import Slider from 'react-slick';
import { productKitArray } from '../../components/libs/constants';
import { currencySymbols } from '../constants';
import { ProductType } from '../libs/typeInterface';

interface IMayLike {
  productData: ProductType[];
  productSelected: string;
  openRedirectModal: State<boolean>;
  type?: string;
}

const MayLike = (props: IMayLike) => {
  const { productData, productSelected, openRedirectModal, type } = props;

  let filteredProduct;

  if (type === 'kit') {
    filteredProduct = productKitArray.filter((item) => !item.id.includes(productSelected));
  } else {
    filteredProduct = productData.filter((item) => !item.id.includes(productSelected));
  }

  function openStore(proLink: string) {
    openRedirectModal.set(true);
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setTimeout(function () {
      document.getElementsByTagName('body')[0].removeAttribute('style');
      openRedirectModal.set(false);
      window.location.href = proLink;
    }, 5000);
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <section className="xs:px-4 lg:px-0 relative w-full flex flex-col items-center justify-center lg:container lg:mx-auto xs:mb-5">
        <div className="w-full flex flex-col">
          <p className="font-breadley-sans xs:text-4xl lg:text-6xl text-customColors-300">
            You may also like
          </p>
          <div className="w-full flex xs:flex-wrap lg:flex-nowrap lg:flex-row items-start justify-start xs:space-y-5 lg:space-y-0 lg:space-x-10 xs:mt-5 lg:mt-10">
            <Slider {...settings} className="w-full">
              {filteredProduct.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="xs:pb-5 lg:pb-0 lg:px-5 xs:w-full xs:flex-none lg:flex-1 items-start justify-start"
                  >
                    <a
                      href={`/${item.id}`}
                      className="w-full xs:h-80 lg:h-100 flex items-center justify-center relative"
                    >
                      {/* <img
                      src="/images/product-bg.jpg"
                      className="w-full h-full absolute left-0 top-0 z-1"
                    /> */}
                      <img src={item.img} className="w-full h-full object-cover" />
                    </a>
                    <div className="w-full flex flex-col space-y-2 mb-4">
                      <a
                        href={`/${item.id}`}
                        className="font-breadley-sans xs:text-3xl lg:text-5xl text-customColors-300"
                      >
                        R&G{' '}
                        {type === 'kit' || item.name.toLowerCase() === 'facewash' ? `` : `Face `}
                        {item.name}
                      </a>
                      <p className="text-base uppercase">
                        MRP :{' '}
                        <span className="text-lg font-semibold">
                          {currencySymbols.rupee}
                          {item.price}
                        </span>
                      </p>
                    </div>
                    <a
                      onClick={() => {
                        openStore(item.link);
                      }}
                      target="_blank"
                      className="cursor-pointer w-full flex items-center justify-center py-2 text-customColors-300 xs:text-sm lg:text-xl uppercase rounded-sm z-10 transition-all duration-300 shop-now shade-0"
                    >
                      {/* Shop Now */}
                      Know More
                    </a>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default MayLike;
